import React from 'react';
import { makeStyles, Theme } from '@material-ui/core/styles';
import FormControl, { FormControlProps } from '@material-ui/core/FormControl';
import cx from 'clsx';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  marginVertical: {
    marginTop: theme.typography.pxToRem(10),
    marginBottom: theme.typography.pxToRem(10)
  },
  formControl: {
    margin: theme.spacing(1),
    textAlign: 'left',
    minWidth: '200px',
    width: 'auto'
  }
}));

export type FilterBarFormControlProps = FormControlProps & { marginDense?: boolean };

const FilterBarFormControl: React.FC<FilterBarFormControlProps> = ({
  children,
  className,
  marginDense,
  ...rest
}) => {
  const classes = useStyles();
  return (
    <FormControl
      className={cx(classes.formControl, { [classes.marginVertical]: !marginDense }, className)}
      {...rest}
    >
      {children}
    </FormControl>
  );
};

export default FilterBarFormControl;
